import { E_TableFilterExchangeType, TableExchangeValue, TableMarketValue } from '@/redux/trades/trades.types'
import { ServicesExchangeID } from '../../../../utils/types/contracts.types'

export const getNameWithExchangeId = (exchange_id: number, type: TableExchangeValue | TableMarketValue) => {
  const foundExchange = (type as Array<{ name: E_TableFilterExchangeType; ids: ServicesExchangeID[] }>).find(exchange =>
    exchange.ids.includes(exchange_id)
  )
  return foundExchange ? foundExchange.name : undefined
}
